import React from 'react';
import {useLocation} from 'wouter';

import {useCreateQueryDraftMutation} from '../hooks/requests/use-create-query-mutation';
import {GlobalVersionData} from '../../../hooks/global-version/use-global-version-query';

interface Props {
    currentGlobalVersion: GlobalVersionData;
}

export function NewQuery({currentGlobalVersion}: Props) {
    const [, navigate] = useLocation();
    const createQueryDraft = useCreateQueryDraftMutation();

    React.useEffect(() => {
        createQueryDraft
            .mutateAsync({
                globalVersionId: currentGlobalVersion.id
            })
            .then((queryInfo) => {
                navigate(`/${queryInfo.id}`);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentGlobalVersion]);

    // TODO Add loading state
    return null;
}
